import { useSale } from "../../../contexts/SaleContext"
import { getItemTaxes, getTotalTaxes, roundValue, textNumberFormater } from "../../../utils"
import React, { useEffect, useState } from "react"
import { Button, Dropdown, InputNumber, Popconfirm, Spin, TableColumnsType, Tag } from "antd"
import { MoreOutlined } from "@ant-design/icons"
import { mutate } from "swr"
import RegisterView from "../RegisterView"

import { useConfig } from "../../../contexts/ConfigContext"
import { useCompany } from "../../../contexts/CompanyContext"
import useAuth from "../../../hooks/useAuth"
import { useCurrentSessionCashFetch, usePosFetch, useSales } from "../../../hooks/useSale"
import { saleStatus } from "../../../config/const"
import { IMovementRS, TModuleOptions } from "../../../models/salesModel"
import { useSecureRequest } from "../../../hooks/useSecureRequest"
import { usePos } from "../../../contexts/PosContext"
import { useUser } from "../../../contexts/UserContext"
import { useSession } from "../../../contexts/CashSessionContext"
import { useRegister } from "../../../contexts/RegisterContext"

function ViewRegisterSale(){
  const { sale, updateSale} = useSale()
  const {pos,updatePos} = usePos()
  const {config} = useConfig()
  const {user} = useUser()
  const {updateSession} = useSession()
  const {company} = useCompany()
  const {register} = useRegister()
  const [spinning,setSpinning] = useState(true)
  const [availableSession,setAvailableSession] = useState(false)
  const { securePost } = useSecureRequest()
  const {taxesOptions} = register
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:saleData} = useSales(tokenData,{
    company:company.current.uid,
    status:saleStatus.PENDING,
    documentType: "SALE_INVOICE",
    first: true,
    createdBy: user.document_number,
    module: config.module
  },company.current.id)
  const {data:posData} = usePosFetch(tokenData,{
    all:true,
    company:company.current.uid,
  },company.current.id)
  const {data:currentSessionData} = useCurrentSessionCashFetch(tokenData,{
    company:company.current.uid,
    idUser: user.document_number
  },company.current.id)
  // Reset spinner and session state when company changes
  useEffect(() => {
    setSpinning(true);
    setAvailableSession(false);
    updateSale({
      currentPending: null,
      item_list: []
    });
  }, [company.current.uid]);

  useEffect(()=>{
    if (saleData) {
      const firstMovement = saleData?.movement || (saleData?.movementList?.[0])
      if(firstMovement?.uid){
        updateSale({
          currentPending: firstMovement,
          item_list: firstMovement.item_list || []
        })
      } else {
        updateSale({
          currentPending: null,
          item_list: []
        })
      }
    }
  },[saleData])

  useEffect(()=>{
    if(currentSessionData){
      if(currentSessionData.cashSessionList?.[0]){
        updateSession({currentSelected: currentSessionData.cashSessionList[0]})
        setAvailableSession(true)
      }else{
        setAvailableSession(false)
      }
      setSpinning(false)
    }
  },[currentSessionData])

  useEffect(()=>{
    const list = posData?.pos || posData?.posList
    if(list && Array.isArray(list) && list.length > 0){
      const defaultPos = list.find((el: any) => el.is_default) || list[0]
      updatePos({
        list: list,
        currentSelected: pos.currentSelected?.uid ? pos.currentSelected : defaultPos
      })
    }
  },[posData])

  const deleteItem = (index:number)=>{
    const item_list = sale.item_list
    if(item_list.length <= 1){
      alert("No es posible eliminar el único artículo del registro. Para descartar la venta completa, puede hacerlo desde la sección de ventas pendientes.")
      return
    }
    const newItemlist = item_list.filter((_el,i)=>i!==index)
    updateSale({item_list:newItemlist})
    updateValuesFromDelete(newItemlist)
  }

  const rowMenu = (record: any) => {
    const isOnlyItem = (sale.item_list?.length || 0) <= 1
    const items = [
      {
        key: '1',
        disabled: isOnlyItem,
        label: isOnlyItem ? (
          <span style={{ color: '#bfbfbf', cursor: 'not-allowed' }} title="No se puede eliminar el único elemento de la venta">
            Eliminar
          </span>
        ) : (
          <Popconfirm
            title="¿Está seguro de eliminar este ítem?"
            onConfirm={() => deleteItem(record.register - 1)}
            okText="Sí"
            cancelText="No"
          >
            <a>Eliminar</a>
          </Popconfirm>
        ),
      },
    ];
    return (
      <Dropdown menu={{ items }} trigger={['click']}>
        <Button icon={<MoreOutlined />} type="text" />
      </Dropdown>
    );
  };

  const updateValuesFromDelete = async (newItemlist:any)=>{
    setSpinning(true)
    const {currentPending} = sale
    if(!currentPending) return setSpinning(false)
    const subTotal = newItemlist.reduce((acc:any,obj:any)=>acc+obj.total_amount,0)
    const discount = newItemlist.reduce((acc:any,obj:any)=>acc+obj.discount_amount,0)
    const total_tax_amount = newItemlist.reduce((acc:any,obj:any)=>acc+obj.total_tax_amount,0)
    const taxes = getTotalTaxes(newItemlist)
    const {created_at,...saleData} = {
      ...currentPending,
      items: newItemlist.length,
      item_list: newItemlist,
      total_amount: subTotal,
      total_amount_full: subTotal + total_tax_amount,
      total_amount_net: subTotal + total_tax_amount - discount,
      taxes_list: taxes,
      total_discount_amount: discount,
      total_tax_amount
    }

    const deleteResponse = await securePost("/inventory/movement/update-movement",{
      company:company.current.uid,
      uidMovement:currentPending.uid,
      movement: saleData,
      module: config.module,
      typeMovement: "REGISTER_SALE"
    })
    if(deleteResponse.status === 200){
      updateSale({item_list:newItemlist,currentPending: newItemlist.length === 0 ? null : saleData})
      mutate(
        key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
        undefined,
        { revalidate: true }
      )
    }else{
      alert("Por favor intente de nuevo")
    }
    setSpinning(false)
  }

  const columnsSale:TableColumnsType = [
    {title:"#",dataIndex:"register"},
    {
      title:"Articulo",
      dataIndex:"name",
      render: (text, record) => (
        <div>
          <span>{text}</span>
          {record.stock_override && (
            <Tag color="orange" style={{ marginLeft: 6 }}>
              Sin Stock
            </Tag>
          )}
        </div>
      )
    },
    {title:"Cantidad",dataIndex:"quantity",render:(text,_r,index) => getQuantityElement(text,index)},
    {title:"Presentación",dataIndex:"display"},
    {title:"Precio",dataIndex:"client_unit_price",render: (text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
    {title:"Descuento(%)",dataIndex:"discount_rate",render: (text,_,index)=>getDiscountElement(text,index)},
    {title:"Total",dataIndex:"client_amount",render:(text)=><label className="numeric-values-data-table">{textNumberFormater(text)}</label>},
    {title:"Acciones",key:"actions",render:(_, record) => rowMenu(record)}
  ]

  const handleAddElement = () => {
    if(pos.list.length === 0){
      alert("Debe crear al menos un punto de venta")
    }else{
      updateSale({showAddItem:true})
    }
  }

  let subTotal = 0   
  const title="Registrar nueva venta en " + (pos.currentSelected?.name || "punto de venta")
  const columnsData = columnsSale
  const footerElement = () => <Button type="dashed" onClick={handleAddElement}>Añadir articulo</Button>
  const itemList = sale.item_list?.map((el)=>{
    const client_amount = roundValue(el.unit_price * el.quantity + el.total_tax_amount - el.discount_amount)
    const client_unit_price = roundValue((el.unit_price * el.quantity + el.total_tax_amount) / (el.quantity || 1))
    subTotal += client_amount
    const code = el.custom_id || el.key || el.uid
    return {
      ...el,
      code,
      client_amount,
      client_unit_price
    }
  }) || []

  function getDiscountElement(text:string,index:number){
    if(index !== sale.editableDiscountField){
      return (<button className="cell-selectable-values-center link-button" onClick={()=>setDiscountEditable(index)}>{textNumberFormater(text)}</button>)
    }
    if(index === sale.editableDiscountField){
      return (<InputNumber id="discount" name="discount" required min={0} max={100} suffix="%" autoFocus defaultValue={Number(text)} 
      onBlur={(e) => updateValues(e,index,"discount")} onKeyDown={(e) => updateValues(e,index,"discount")}></InputNumber>)
    }
    return (<label>{text}</label>)
  }
  function getQuantityElement(text:string,index:number){
    if(index !== sale.editableQuantityField){
      return (<button className="cell-selectable-values-center link-button" onClick={()=>setQuatityEditable(index)}>{text}</button>)
    }
    if(index === sale.editableQuantityField){
      return (<InputNumber id="quantity" name="quantity" required min={1} autoFocus defaultValue={Number(text)} 
      onBlur={(e) => updateValues(e,index,"quantity")} onKeyDown={(e) => updateValues(e,index,"quantity")}></InputNumber>)
    }
    return (<label>{text}</label>)
  }
  const setQuatityEditable = (i:number) => {
    updateSale({editableQuantityField: i})
  }
  const setDiscountEditable = (i:number) => {
    updateSale({editableDiscountField: i})
  }
  const computeNewValues = async (index: number, newVal: number, column: "discount" | "quantity"): Promise<boolean> => {
    const item = sale.item_list[index]
    if (!item) return false

    if (column === "quantity") {
      let availableQty = 0

      if (item.register_type === "PRODUCT") {
        const itemUid = item.uid
        if (itemUid) {
          try {
            const itemResponse = await securePost('/inventory/item/get-item', {
              company: company.current.uid,
              uidItem: itemUid,
              module: config.module
            })
            if (itemResponse?.status === 200 && itemResponse?.inventoryItem) {
              const freshItem = itemResponse.inventoryItem
              const storehouseUid = pos.currentSelected?.storehouse_uid
              const storehouseId = pos.currentSelected?.storehouse_id || pos.currentSelected?.id
              const invEntry = (freshItem.inventory || []).find((inv: any) =>
                (storehouseUid && inv.uid === storehouseUid) ||
                (storehouseId && (inv.storehouse_id === storehouseId || inv.id === storehouseId))
              )
              availableQty = invEntry ? invEntry.quantity : 0
            } else {
              const matchedProduct = (register.registerList || []).find((reg: any) =>
                (reg.uid && reg.uid === item.uid) ||
                (reg.custom_id && reg.custom_id === item.item_code) ||
                (reg.id && reg.id === item.element_id)
              )
              if (matchedProduct) {
                const storehouseId = pos.currentSelected?.storehouse_id
                const invEntry = (matchedProduct.inventory || []).find((inv: any) => inv.storehouse_id === storehouseId)
                availableQty = invEntry ? invEntry.quantity : 0
              }
            }
          } catch (e) {
            console.error("Error fetching fresh item stock:", e)
          }
        }
        item.quantity_available = availableQty

        // Validar disponibilidad en tiempo real para productos
        if (newVal > availableQty) {
          const canAuthorize = user.permissions.actions?.includes('sales.action.movement.stock_override') || 
                                user.roles?.some((r: any) => ['SUPER_ADMIN', 'ADMIN_COMPANY', 'SALES_ADMIN'].includes(r.role_name) || ['SUPER_ADMIN', 'ADMIN_COMPANY', 'SALES_ADMIN'].includes(r.name))
          if (!canAuthorize) {
            updateSale({ editableQuantityField: -1 })
            alert(`La cantidad elegida (${newVal}) supera el inventario disponible actual de "${item.name || item.item_name}" (${availableQty}).`)
            return false
          }
          const reason = window.prompt(
            `La cantidad elegida (${newVal}) supera el inventario disponible actual de "${item.name || item.item_name}" (${availableQty}).\n\nPor favor ingrese el motivo para autorizar esta venta sin inventario disponible (OBLIGATORIO):`
          )
          if (!reason?.trim()) {
            alert("Operación cancelada: Se requiere ingresar el motivo para autorizar la cantidad sin inventario.")
            updateSale({ editableQuantityField: -1 })
            return false
          }
          item.stock_override = true
          item.stock_override_reason = reason.trim()
          if (sale.currentPending) {
            sale.currentPending.stock_override = true
            sale.currentPending.stock_override_reason = reason.trim()
            sale.currentPending.stock_override_by_user_id = user.id
          }
        }
      }

      item.discount_amount = roundValue(newVal * (item.unit_price * (item.discount_rate / 100)))
      item.quantity = newVal
      item.total_amount = roundValue(newVal * item.unit_price)
    }
    if (column === "discount") {
      if (newVal >= 100) {
        updateSale({ editableDiscountField: -1 })
        alert("El descuento no puede superar el valor total del elemento")
        return false
      }
      item.discount_amount = roundValue(newVal * (item.unit_price * (item.quantity / 100)))
      item.discount_rate = newVal
    }
    const taxes_list = getItemTaxes(item, taxesOptions)
    item.taxes_list = taxes_list
    taxes_list.forEach(tax => tax.tax_amount = roundValue(tax.tax_amount))
    const taxAmount = roundValue(taxes_list.reduce((acc, el) => acc + el.tax_amount, 0))
    item.total_tax_amount = taxAmount
    const fullPrice = roundValue(item.total_amount + taxAmount)
    const netPrice = roundValue(item.total_amount - (item.discount_amount || 0) + taxAmount)
    item.total_amount_full = fullPrice
    item.total_amount_net = netPrice
    return true
  }
  const updateValues = async (event: any, index: number, column: "discount" | "quantity") => {
    if (event.key === "Enter" || event.type === "blur") {
      const newVal = Number.parseInt(event.target.value)
      if (newVal > 0 || (column === "discount" && newVal >= 0)) {
        console.log("Modificado:", newVal)
        setSpinning(true)
        const success = await computeNewValues(index, newVal, column)
        if (!success) {
          setSpinning(false)
          if (column === "quantity") updateSale({ editableQuantityField: -1 })
          if (column === "discount") updateSale({ editableDiscountField: -1 })
          return
        }
        const subTotal = roundValue(sale.item_list.reduce((acc, obj) => acc + obj.total_amount, 0))
        const totalDiscount = roundValue(sale.item_list.reduce((acc, obj) => acc + obj.discount_amount, 0))
        console.log("Subtotal", subTotal)        
        const currentPending = sale.currentPending as IMovementRS
        currentPending.total_amount = subTotal
        currentPending.total_discount_amount = totalDiscount
        const taxes_list = getTotalTaxes(sale.item_list)
        taxes_list.forEach(tax => tax.tax_amount = roundValue(tax.tax_amount))
        const taxAmount = roundValue(taxes_list.reduce((acc, el) => acc + el.tax_amount, 0))
        currentPending.total_tax_amount = taxAmount
        currentPending.taxes_list = taxes_list
        currentPending.item_list = sale.item_list
        currentPending.total_amount_full = roundValue(sale.item_list.reduce((acc, obj) => acc + obj.total_amount_full, 0))
        currentPending.total_amount_net = roundValue(sale.item_list.reduce((acc, obj) => acc + obj.total_amount_net, 0))

        const {id,uid,created_at,...newPending} = currentPending
        const updateResponse = await securePost("/inventory/movement/update-movement",{
          company:company.current.uid,
          uidMovement:uid,
          movement: { ...newPending },
          module: config.module,
          typeMovement: "REGISTER_SALE"
        })
        setSpinning(false)
        if(updateResponse.status === 200){
          updateSale({ item_list: [...sale.item_list], currentPending })
          mutate(
            key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
            undefined,
            { revalidate: true }
          )
        }else{
          alert("Por favor intente de nuevo")
        }
      }
      if(column === "quantity"){
        updateSale({editableQuantityField: -1})
      }
      if(column === "discount"){
        updateSale({editableDiscountField: -1})
      }
    }
  }
  const addPending = (acept:boolean) => {
    if(sale.item_list.length === 0){
      return alert("Debe añadir elementos al registro")
    }
    if(acept){
      const {currentPending} = sale as {currentPending:IMovementRS}
      currentPending.total_amount = currentPending.item_list.reduce((acc,obj)=>acc+obj.total_amount,0)
      updateSale({showBill: true,currentPending})
    }else{
      updateSale({item_list: [],currentPending:null})
      mutate(
        key => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/inventory/movement'),
        undefined,
        { revalidate: true }
      )
    }
  }

  if(!availableSession && company.salePlan?.key !== "BASIC"){
    return(<>
      <>No hay una sesión Iniciada para el usuario {user.document_number}</>
      <Spin size="small"/>
    </>)
  }
  return (
    <RegisterView 
      title={title}
      spinning={spinning}
      columnsData={columnsData} 
      itemList={itemList}
      subTotal={subTotal}
      footerElement={footerElement}
      addPending={addPending}>
    </RegisterView>
  )
}

export default ViewRegisterSale